import React, { useEffect, useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import '../../css/transaction.css';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [transactionData, setTransactionData] = useState(null);
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // First try to get data from server-injected data
    if (window.BEETZEE_TRANSACTION_DATA) {
      const data = window.BEETZEE_TRANSACTION_DATA;
      setTransactionData({
        transactionId: data.transaction_id,
        merchantRef: data.merchant_ref_code,
        amount: data.amount ? parseFloat(data.amount).toFixed(2) : '0.00'
      });
    } else {
      // Fallback to URL parameters
      const transactionId = searchParams.get('transaction_id');
      const merchantRef = searchParams.get('merchant_ref_code');
      const amount = searchParams.get('amount');
      
      if (transactionId && merchantRef && amount) {
        setTransactionData({
          transactionId,
          merchantRef,
          amount: parseFloat(amount).toFixed(2)
        });
      }
    }

    // Notify parent window about payment success
    try {
      // Store payment status in localStorage
      localStorage.setItem('paymentStatus', JSON.stringify({
        status: 'success',
        timestamp: Date.now(),
        transactionData: transactionData
      }));

      // Try to communicate with parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'PAYMENT_SUCCESS',
          data: transactionData
        }, '*');
      }
    } catch (error) {
      console.error('Error communicating payment success:', error);
    }
  }, [searchParams, transactionData]);

  // Auto-close countdown effect
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Close the window/tab when countdown reaches 0
      window.close();
    }
  }, [countdown]);

  const handleManualClose = () => {
    window.close();
  };

  return (
    <div className="transaction-container">
      <div className="transaction-card success-card">
        <div className="transaction-icon success-icon">
          <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#10B981" strokeWidth="2" fill="#F0FDF4"/>
            <path d="m9 12 2 2 4-4" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h1 className="transaction-title success-title">Payment Successful!</h1>
        <p className="transaction-message">
          Your payment has been processed successfully. Thank you for your booking!
        </p>

        {transactionData && (
          <div className="transaction-details">
            <div className="detail-row">
              <span className="detail-label">Transaction ID:</span>
              <span className="detail-value">{transactionData.transactionId}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Reference Number:</span>
              <span className="detail-value">{transactionData.merchantRef}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Amount Paid:</span>
              <span className="detail-value">₱{transactionData.amount}</span>
            </div>
          </div>
        )}

        <div className="countdown-section">
          <div className="countdown-display">
            <p>This window will close automatically in</p>
            <div className="countdown-timer success-timer">{countdown}</div>
            <p>seconds</p>
          </div>
          <button onClick={handleManualClose} className="btn btn-secondary close-now-btn">
            Close Now
          </button>
        </div>

        {/* <p className="transaction-note">
          A confirmation email has been sent to your registered email address.
        </p> */}
      </div>
    </div>
  );
};

export default PaymentSuccess;